import React from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { TYPE_DESCRIPTION_TABLE } from '@bingads-webui-campaign/recommendation-core';

export class NavigateModal extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    onYes: PropTypes.func.isRequired,
    onNo: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    recommendationType: PropTypes.string.isRequired,
  };

  onYes = () => {
    this.props.onYes();
  };

  onNo = () => {
    this.props.onNo();
  };

  render() {
    const { i18n, isOpen, recommendationType } = this.props;
    const recommendationDescription = i18n.getString(TYPE_DESCRIPTION_TABLE[recommendationType]);
    const i18nKey = 'Recommendation_Feedback_Dismiss_Suggest_Recommendation_Notification';
    return (
      <ReactModal
        isOpen={isOpen}
        overlayClassName="navigate-overlay react-modal-overlay"
        className="navigate-modal react-modal"
        onRequestClose={this.onNo}
      >
        <button
          className="close closeimage"
          onClick={this.onNo}
          aria-label={i18n.getString('Button_Close')}
        />
        <div>
          <div className="navigate-text">
            {i18n.getString(i18nKey, { recommendationDescription })}
          </div>
          <span className="navigate-action">
            <button className="navigate-button navigate-button-yes btn-primary" onClick={this.onYes}>
              {i18n.getString('Filter_BooleanFilter_Yes')}
            </button>
            <button className="navigate-button navigate-button-no btn-default" onClick={this.onNo}>
              {i18n.getString('Filter_BooleanFilter_No')}
            </button>
          </span>
        </div>
      </ReactModal>
    );
  }
}
